import React from 'react'
import styled from 'styled-components'
import { formatMoney, formatShortDate } from 'utility/crm/dates'
import { Avatar, Muted, Pill, Row, surface, textColor } from './ui'

const Box = styled.div`
    border: 1px solid ${({ $warn }) => ($warn ? 'rgba(220,38,38,.6)' : 'rgba(128,128,128,.35)')};
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 8px;
    background: ${surface};
    color: ${textColor};
    cursor: pointer;
    box-shadow: ${({ $dragging }) => ($dragging ? '0 8px 20px rgba(0,0,0,.25)' : 'none')};
    &:focus-visible {
        outline: 2px solid #2563eb;
    }
    .account {
        font-weight: 700;
    }
    .name {
        font-size: 0.85rem;
        opacity: 0.8;
        overflow-wrap: anywhere;
    }
    .amount {
        font-weight: 600;
        margin-top: 6px;
    }
`

/**
 * One deal on the board. Opens with Enter or Space; text is rendered as plain text.
 * @param {{ deal: import('utility/crm/types').CrmDeal, onOpen: (deal: import('utility/crm/types').CrmDeal) => void,
 *   dragging?: boolean, innerRef?: any } & Record<string, any>} props
 */
export const DealCard = ({ deal, onOpen, dragging = false, innerRef, ...rest }) => {
    const warn = deal.Status === 'open' && deal.IsPastClose
    return (
        <Box
            ref={innerRef}
            role="button"
            tabIndex={0}
            $dragging={dragging}
            $warn={warn}
            aria-label={`Open deal ${deal.AccountName}: ${deal.Name}`}
            onClick={() => onOpen(deal)}
            onKeyDown={event => {
                // Enter opens; Space is left to the drag handle (keyboard lift).
                if (event.key === 'Enter' && event.target === event.currentTarget) onOpen(deal)
            }}
            {...rest}
        >
            <div className="account">{deal.AccountName}</div>
            <div className="name">{deal.Name}</div>
            <div className="amount">{formatMoney(deal.Amount)} ARR</div>
            <Row $between $gap={6} style={{ marginTop: 4 }}>
                <Muted>{deal.CloseDate ? `Close ${formatShortDate(deal.CloseDate)}` : 'No close date'}</Muted>
                {deal.OwnerName ? <Avatar name={deal.OwnerName} size={24} /> : null}
            </Row>
            <Row $gap={6} $wrap style={{ marginTop: 6 }}>
                {deal.Status === 'won' ? <Pill $tone="green">Won</Pill> : null}
                {deal.Status === 'open' && deal.IsStuck ? <Pill $tone="amber">{deal.DaysInStage}d in stage</Pill> : null}
                {warn ? <Pill $tone="red">Close date passed</Pill> : null}
            </Row>
        </Box>
    )
}
